module.exports = __webpack_public_path__ + "static/media/shop_bg.0febc6e3.png";